(function () {
  function initWhatToExpect(section) {
    if (
      !section ||
      section.dataset.whatToExpectInitialized === 'true'
    ) {
      return;
    }

    const track = section.querySelector('.what-to-expect__slides');
    const slides = section.querySelectorAll('[data-expect-slide]');
    const prevButton = section.querySelector('.what-to-expect__nav--prev');
    const nextButton = section.querySelector('.what-to-expect__nav--next');

    if (
      !track ||
      slides.length < 2 ||
      !prevButton ||
      !nextButton
    ) {
      return;
    }

    section.dataset.whatToExpectInitialized = 'true';

    const getCurrentIndex = () => {
      const trackRect = track.getBoundingClientRect();

      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();

        const distance = Math.abs(
          slideRect.left - trackRect.left
        );

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const scrollToSlide = (index) => {
      const targetIndex = Math.max(
        0,
        Math.min(index, slides.length - 1)
      );

      slides[targetIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    };

    const updateNavigation = () => {
      const currentIndex = getCurrentIndex();

      prevButton.disabled = currentIndex === 0;
      nextButton.disabled =
        currentIndex === slides.length - 1;
    };

    prevButton.addEventListener('click', () => {
      scrollToSlide(getCurrentIndex() - 1);
    });

    nextButton.addEventListener('click', () => {
      scrollToSlide(getCurrentIndex() + 1);
    });

    let scrollFrame;

    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(scrollFrame);

        scrollFrame = requestAnimationFrame(() => {
          updateNavigation();
        });
      },
      { passive: true }
    );

    updateNavigation();
  }

  function initAllWhatToExpect(root) {
    const context = root || document;

    if (
      context.matches &&
      context.matches('[data-what-to-expect]')
    ) {
      initWhatToExpect(context);
    }

    context
      .querySelectorAll('[data-what-to-expect]')
      .forEach(initWhatToExpect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllWhatToExpect(document);
    });
  } else {
    initAllWhatToExpect(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllWhatToExpect(event.target);
  });
})();